import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import styles from './SignDetails.module.scss';
const SignDetails = ({ data, className }) => {
    const { t } = useTranslation();
    const { author, coauthor } = data;
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: [author && (_jsxs("div", Object.assign({ className: styles.signer }, { children: [t('label.signed'), " ", formatDate(author.time), " \u2022 ", author.name] }))), coauthor && (_jsxs("div", Object.assign({ className: styles.cosigner }, { children: [t('label.co-signed'), " ", formatDate(coauthor.time), " \u2022 ", coauthor.name] })))] })));
};
export default observer(SignDetails);
